export default __webpack_public_path__ + "static/media/play-circle-outline.af6f706d.svg";